module.exports = __webpack_public_path__ + "static/media/carolparentswedding81.3a577c96.png";